var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "slider-box"
  }, [_vm.sliderTitle ? _c('div', {
    staticClass: "heading-3-regular title"
  }, [_vm._v(_vm._s(_vm.sliderTitle))]) : _vm._e(), _vm.sliderDescription ? _c('div', {
    staticClass: "paragraph-1 content"
  }, [_vm._v(_vm._s(_vm.sliderDescription))]) : _vm._e(), _vm.sliderImage ? _c('img', {
    attrs: {
      "src": _vm.sliderImage
    }
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }